import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { StoreService } from 'src/app/common/services/store.service';
//import { LoadCatchmentComponent } from '../load-catchment/load-catchment.component';
import { ConfirmDialogBoxComponent } from 'src/app/common/components/confirm-dialog-box/confirm-dialog-box.component';
import { SharedService } from 'src/app/common/services/shared.service';
import { ReportMapService } from 'src/app/reports/services/report-map.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { SaveFilterComponent } from 'src/app/common/components/save-filter/save-filter.component';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { CatchmentModelComponent } from './catchment-model/catchment-model.component';
import { actionIdConstants } from 'src/app/common/constants/common.contants';
import { UserService } from 'src/app/common/services/user.service';
import { activityPayload } from 'src/app/common/models/userActivity.model';

@Component({
  selector: 'app-draw-catchment',
  templateUrl: './draw-catchment.component.html',
  styleUrls: ['./draw-catchment.component.scss']
})
export class DrawCatchmentComponent implements OnInit, OnChanges {

  @Input() drawnPolygons: any;
  @Input() filterList: any;
  @Input() polygon_chip: any;
  @Input() polygon_create: boolean = false;

  @Output() polygonRemove = new EventEmitter();
  @Output() catchmentExpandCol = new EventEmitter();
  @Output() resetCatchmentConfirm = new EventEmitter();
  @Output() loadCatchmentModel = new EventEmitter();
  @Output() drawNewCatchmentLoad = new EventEmitter();

  catchmentExpandList: boolean = false;
  resetCatchment: boolean = false;
  catchmentExistingSelected: boolean = false;
  queryParams: any = null;
  filterDropdownData: any = [];
  langNbr: number;
  queryParamsFirst: any;
  filterLabel: any[] = [];
  selectedCatchmentData: any = null;
  revertCatchment: boolean = false;
  loadCatchmentPopup: boolean = false;
  current_lang: any = null
  loader: boolean = false;
  alreadySelectedCatchment: any = []
  loadCatchmentShow: boolean = false;
  showViewCatchment: boolean = false;
  savedCatchment: any = []
  showSaveBtn = false;
  reportId: number = 0;
  // @ViewChild('existingCatchmentMenuTrigger') existingCatchmentMenuTrigger!: MatMenuTrigger;
  constructor(
    private dailog: MatDialog,
    public storeService: StoreService,
    private translate: TranslateService,
    private sharedService: SharedService,
    private activatedRoute: ActivatedRoute,
    private mapService: ReportMapService,
    public reportService: ReportService,
    private alertService: AlertService,
    private router: Router,
    private userService: UserService,
  ) {
    this.langNbr = this.sharedService.getCurrentLangID();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['filterList']) {
      let dropdowns = changes?.['filterList'].currentValue;
      if (dropdowns.length > 0) {
        this.filterDropdownData = dropdowns;
      }
    }
    if (!this.polygon_create) {
      this.catchmentExpandList = false;

    }

    const savedCatchment: any = this.storeService.getSessionData('filter');

    if (savedCatchment) {
      this.savedCatchment = savedCatchment.data.catchment.features;
      this.drawnPolygons = this.sharedService.compareObjecCountt(this.drawnPolygons, savedCatchment.data.catchment.features)
    }

    if(savedCatchment && this.drawnPolygons.length >= savedCatchment.data.catchment.features.length){
      this.savedCatchment = savedCatchment.data.catchment.features
      this.alreadySelectedCatchment = this.drawnPolygons.filter((data: any) => data?.alreadySaved)?.length;
    } else {
      this.alreadySelectedCatchment = this.getSelectedCatchment(this.storeService.getSessionData('filter'));
    }


  }

  ngOnInit(): void {
    this.sharedService.language$.subscribe((lang) => {
      this.current_lang = lang;

    });
    this.getActivateRoute();
    this.reportService.reloadCatchment$.subscribe((data: boolean) => {
      this.alreadySelectedCatchment = this.getSelectedCatchment(this.storeService.getSessionData('filter'));
      const savedCatchment: any = this.storeService.getSessionData('filter');

      if (savedCatchment) {
        this.savedCatchment = savedCatchment.data.catchment.features;
        this.drawnPolygons = this.sharedService.compareObjecCountt(this.drawnPolygons, savedCatchment.data.catchment.features)
      }
      this.storeService.addSessionData("queryParamsFirst", this.queryParams)

    })

    if(!this.reportService.savedCatchmentList.length){
      this.searchReport()
    }

     this.reportId = this.activatedRoute.snapshot.queryParams['rid'];

  }

  searchReport(event: any = ''){
    this.reportService.savedFilterList(event).subscribe((data: any) => {
      this.reportService.savedCatchmentList = data.data;
    });
  }


  getActivateRoute() {
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.queryParams = params;
      let currentParams = { ...params };
      this.catchmentExistingSelected = false;
      let savefilter: any = this.storeService.getSessionData('filter');
      this.queryParamsFirst = {
        "oid": this.queryParams['oid'],
        "gid": this.queryParams['gid'],
        "rid": this.queryParams['rid']
      }
      if (savefilter) {
        this.queryParamsFirst = { ...this.queryParamsFirst, ...savefilter.data.filter }
        this.alreadySelectedCatchment = Math.min(savefilter.data.catchment.features.length,this.drawnPolygons.length)
      }



      if (this.storeService.getSessionData("queryParamsFirst")) {
        this.queryParamsFirst = this.storeService.getSessionData("queryParamsFirst");
      }

    });

  }

  loadSaved() {
    if (this.alreadySelectedCatchment !== this.drawnPolygons.length) {
      this.dailog.open(CatchmentModelComponent, {
        disableClose: true,
        panelClass: 'load-catchment',
        data: {
          type: 'load'
        }
      }).afterClosed().subscribe((res: any) => {
        if (res) {
          this.loadCatchment();
        }
      })
    } else {
      this.loadCatchment();
    }

  }

  resetCatchmentOpen() {
    this.dailog.open(CatchmentModelComponent, {
      disableClose: true,
      panelClass: 'load-catchment',
      data: {
        type: 'reset'
      }
    }).afterClosed().subscribe((res: any) => {
      if (res) {
        this.resetCatchmentLayer();
      }
    })


  }

  removeCatchment() {
    this.sharedService.clearSession('filter');
    this.resetCatchmentLayer();
  }

  revertCatchmentOpen() {
    this.dailog.open(CatchmentModelComponent, {
      disableClose: true,
      panelClass: 'load-catchment',
      data: {
        type: 'revert'
      }
    }).afterClosed().subscribe((res: any) => {
      if (res) {
        this.revertLayer()
      }
    })


  }

  catchmentExpand() {
    this.catchmentExpandList = !this.catchmentExpandList;
    this.catchmentExpandCol.emit(this.catchmentExpandList)
  }

  polygonWKTRemove(polygon: any) {
    const _data = {
      parent_data: null,
      message: this.translate.instant('map.do_you_want_to_remove_the_catchment'),
      inputbox: true
    };
    this.dailog.open(ConfirmDialogBoxComponent, {
      width: '400px',
      height: 'auto',
      data: _data,
      disableClose: true
    }).afterClosed().subscribe((res: any) => {
      if (res) {

        this.polygonRemove.emit(polygon)

      }
    });
  }

  savedFilterName(event: any, existingCatchemnt: boolean = false) {
    if (this.reportService.getLockReport()) {
      return;
    }
    this.showViewCatchment = true;
    let qParams = { ...this.queryParams };
    this.mapService.zoom.subscribe(res => {
      qParams['zoom'] = res;
    })
    if (this.mapService.getCentroid()) qParams['centroid'] = this.mapService.getCentroid();
    let _data = {
      filterData: qParams,
      filterDropdownData: this.filterDropdownData
    };
    if (existingCatchemnt) {
      this.saveExicitingCatchment(_data);
    } else {
      this.dailog.open(SaveFilterComponent, {
        data: _data
      }).afterClosed().subscribe(res => { 
          if(res) {
          const activity:activityPayload = {
                userdata: { data: res },
                actionId: actionIdConstants.save_catchment,
                entity: 'report',
                entityId: this.reportId,
              };
              this.userService.logUserActivity(activity);
          }
      })
    }
        // Log user activity
   
  }

  getSaveFilter() {
    let savefilter: any = this.storeService.getSessionData('filter');
    if (savefilter) {
      // this.selectedSaveFilter = savefilter?.data?.filter;
      return savefilter?.name || '';
    }
    return '';
  }

  saveExicitingCatchment(data: any) {
    let savedFilter = this.storeService.getSessionData("filter")
    let datas: { [key: string]: string } = { ...data.filterData }
    let polygon: any;
    if (datas['polygon']) {
      polygon = datas['polygon'];
    }
    for (let key in datas) {
      if (['rid', 'srid', 'gid', 'oid', 'polygon'].includes(key)) {
        delete datas[key];
      } else {
        let temp = { ...datas }
        temp['label'] = this.getLabel(key, datas[key])
      }
    }
    /**
     * Send label object in api
     */
    for (const [key, value] of Object.entries(datas)) {
      if (key !== 'zoom' && key !== 'centroid') {
        let data = value?.includes(',') ? value.split(',') : [value]

        const parameterMap: any = {};
        data.forEach((item: any) => {
          if (parameterMap[key]) {
            parameterMap[key].data.push({ value: item, label: this.getLabel(key, item) });
          } else {
            let filter = this.filterDropdownData.find((f: any) => f.parameter_name == key);
            parameterMap[key] = { parameter_name: filter.label, data: [{ value: item, label: this.getLabel(key, item) }] };
            this.filterLabel.push(parameterMap[key]);
          }
        });

      }
    }
    const user: any = this.sharedService.getUserInfo();

    let payload = {
      "user_id": user?.user_id,
      "filter_type": "filter",
      "filter_data": {
        "catchment": polygon ? JSON.parse(polygon) : null,
      }
    }
    this.queryParamsFirst = this.queryParams;
    this.loader = true;

    this.storeService.addSessionData("queryParamsFirst", this.queryParams)

    this.reportService.updateSavedFilter(payload, savedFilter).subscribe({
      next: (res: any) => {
        this.loader = false;
        this.reportService.reloadCatchment$.next(true)
        if (res && res?.status == 200) {
          this.catchmentExistingSelected = false;
          this.alertService.success(res.message)
          // this.reportService.getSavedFilter()
          const savefilter: any = { ...this.storeService.getSessionData('filter') };
          savefilter.data.catchment = polygon ? JSON.parse(polygon) : null,
            this.storeService.addSessionData("filter", savefilter)
          this.reportService.reloadCatchment$.next(true)

          const activity:activityPayload = {
            userdata: { data: payload },
            actionId: actionIdConstants.save_catchment,
            entity: 'report',
            entityId: this.reportId,
          };
          this.userService.logUserActivity(activity);

        } else {
          this.alertService.warn(res.message)
        }
      },
      error: (err: any) => {
        this.loader = false;
        this.alertService.error(err.message)
      }
    });

  }

  getLabel(key: string, value: string) {
    let filter = this.filterDropdownData.find((f: any) => f.parameter_name == key);
    if (filter && filter.value_list?.length) {
      let f_value_obj = filter.value_list.find((e: any) => e.val == value);
      if (f_value_obj) {
        return f_value_obj.label;
      }
    }
    return { [this.langNbr]: value } //this.sharedService.removeUnderscores(value);
  }

  resetCatchmentLayer() {
    this.resetCatchment = false;
    this.resetCatchmentConfirm.emit(true)
  }

  revertLayer(event: any = '') {
    this.revertCatchment = false;
    this.router.navigate([`${this.sharedService.CityLang}/${GlobalContants.Routes.Reports}`], {
      queryParams: this.queryParamsFirst
    });

  }


  getSelectedCatchment(catchment: any) {
    if (!catchment) {
      return 0
    }
    return catchment?.data?.catchment.features?.length
  }


  loadCatchment() {
    this.loadCatchmentModel.emit(true)
  }

  closeLoadCatchment(event: any) {
    this.loadCatchmentShow = false;
  }

  drawNewCatchment() {
    this.drawNewCatchmentLoad.emit(true)
  }

}
